import type { RouteObject } from "react-router-dom";
import { ConductNotificationExitPage } from "../pages/ConductNotificationExitPage";
export const adminConductDetailRoutes: RouteObject[] = [
  {
    path: "admin/conduct/create",
    lazy: async () =>
      (await import("@/features/admin-conduct/route")).loadConductWizardRoute(),
  },
  {
    path: "admin/conduct/records/:recordId/notify/:parentMode",
    lazy: async () =>
      (
        await import("@/features/admin-messaging/route")
      ).loadConductMessageWorkflowRoute(),
    children: [
      { index: true, Component: ConductNotificationExitPage },
      ...(
        [
          ["recipients", "loadMessageRecipientsRoute"],
          ["compose", "loadMessageComposeRoute"],
          ["preview", "loadMessagePreviewRoute"],
          ["approval", "loadMessageApprovalRoute"],
        ] as const
      ).map(([path, loader]) => ({
        path,
        lazy: async () =>
          (await import("@/features/admin-messaging/route"))[loader](),
      })),
    ],
  },
];
